import React from "react";
import {
  FaBuilding,
  FaCartShopping,
  FaLayerGroup,
  FaFileLines,
  FaPalette,
  FaArrowsRotate,
  FaLink,
  FaShieldHalved,
} from "react-icons/fa6";
import { Container, H3_SIZE } from "../home/ui";
import WebSectionHead, { CtaButton } from "./WebSectionHead";

const services = [
  { icon: FaBuilding, title: "Business Websites", text: "Professional websites to establish your brand online.", tone: "bg-[#E3F0FF] text-[#1E6BFF]", href: "/service/website-design-development-solutions" },
  { icon: FaCartShopping, title: "E-commerce Websites", text: "Feature-rich online stores to sell your products.", tone: "bg-[#FFE9E4] text-[#F4511E]", href: "/service/ecommerce-website-design-development-solutions" },
  { icon: FaLayerGroup, title: "Web Applications", text: "Custom web apps for your unique business needs.", tone: "bg-[#E3F0FF] text-[#1E6BFF]", href: "/software-development-services" },
  { icon: FaFileLines, title: "CMS Development", text: "Easy-to-manage websites using popular CMS platforms.", tone: "bg-[#ECEBFF] text-[#4F46E5]", href: "/service/cms-website-design-development-solutions" },
  { icon: FaPalette, title: "UI/UX Design", text: "User-friendly and visually appealing designs.", tone: "bg-[#FFF2DC] text-[#F59E0B]", href: "/contact-us" },
  { icon: FaArrowsRotate, title: "Website Redesign", text: "Modernize your existing website for better results.", tone: "bg-[#E3F7EC] text-[#16A34A]", href: "/contact-us" },
  { icon: FaLink, title: "API Integrations", text: "Seamless integration with third-party tools and services.", tone: "bg-[#F3E6FF] text-[#9333EA]", href: "/contact-us" },
  { icon: FaShieldHalved, title: "Maintenance & Support", text: "Keep your website updated, secure, and running smoothly.", tone: "bg-[#E6EBFF] text-[#2F54EB]", href: "/contact-us" },
];

const WebServices = () => (
  <section className="bg-gradient-to-b from-white to-[#F7F9FF] py-[54px] lg:py-[66px]">
    <Container>
      <WebSectionHead
        pill="What we offer"
        title="Our Website Development Services"
        subtitle="End-to-end website development solutions for businesses of all sizes."
        cta={<CtaButton href="/#services">View All Services</CtaButton>}
      />
      <div className="m-swipe mt-[28px] grid gap-[20px] sm:grid-cols-2 lg:grid-cols-4">
        {services.map((s) => (
          <a
            key={s.title}
            href={s.href}
            className="group rounded-[18px] border-[1px] border-solid border-[#EEF1F8] bg-white p-[22px] shadow-[0_12px_34px_-20px_rgba(40,60,140,0.25)] transition hover:-translate-y-1"
          >
            <span className={`inline-flex h-[48px] w-[48px] items-center justify-center rounded-full text-[20px] ${s.tone}`}>
              <s.icon />
            </span>
            <h3 className={`mt-[16px] font-semibold text-ink transition group-hover:text-[#1E6BFF] ${H3_SIZE}`}>{s.title}</h3>
            <p className="mt-[6px] text-[14.5px] leading-[1.55] text-slate-500">{s.text}</p>
          </a>
        ))}
      </div>
    </Container>
  </section>
);

export default WebServices;
